import { SpecialZoomLevel, ViewMode } from '@react-pdf-viewer/core';
import { t } from 'i18next';

export const createZoomOptions = (numberOfPages: number) => {
  const hasEvenNumOfPages = numberOfPages % 2 === 0;
  const hasMultiplePages = numberOfPages > 1;

  return [
    { value: SpecialZoomLevel.PageFit, label: t('wholePage') },
    { value: SpecialZoomLevel.PageWidth, label: t('pageWidth') },
    ...(hasMultiplePages
      ? [
          {
            value: ViewMode[
              hasEvenNumOfPages ? 'DualPage' : 'DualPageWithCover'
            ] as const,
            label: t('twoPages'),
          },
        ]
      : []),
    { value: 1.5, label: '150%' },
    { value: 1.25, label: '125%' },
    { value: 1, label: '100%' },
    { value: 0.75, label: '75%' },
    { value: 0.5, label: '50%' },
  ];
};
